
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "./src/app/index.js";
              export default OriginalModule.default;
              export * from "./src/app/index.js";